/* eslint-disable */
import newShop from '../newShop.js';
import PriceType from '../cart/priceType.js';

let FirebaseProduct = function(parser, priceType, market, user){
    this.orderTypes = new $.Hashtable();

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    this.getAgelocmeKeyPart = function() {
        let keyPart = null;

        if (this.agelocme) {
            keyPart = this.agelocme.code + '-' + this.agelocme.label + '-' + this.agelocme.name;
        }

        return keyPart;
    };

    this.getSku = function() {
        return this.sku;
    };

    this.getHighlightedSku = function() {
        let rv = this.sku;
        if (this.highlightedSku){
            rv = this.highlightedSku;
        }
        return rv;
    };

    this.getTitle = function() {
        return this.title;
    };

    this.getProductSearchTitle = function() {
        return this.getTitle();
    };

    this.getProductSearchSku = function() {
        return this.getHighlightedSku();
    };

    this.getCountry = function() {
        return this.cntryCd;
    };

    this.getLang = function() {
        return this.lang;
    };

    this.getShortDescr = function() {
        return this.shortDescr;
    };

    this.getSize = function() {
        return this.size;
    };

    this.getLongDescr = function() {
        return this.longDescr;
    };

    this.getDescription = function() {
        let description = this.longDescr;
        if (!description || description.length === 0) {
            return this.shortDescr;
        }
        return description;
    };

    this.getFullImage = function() {
        return this.fullImage.replace("http:", "https:");

    };

    this.getThumbnail = function() {
        return this.thumbnail.replace("http:", "https:");

    };

    this.getScanQualified = function() {
        return this.scanQualified;
    };

    this.getPoints = function() {
        return this.points;
    };

    this.getPointsFixed = function() {
        return parseFloat(this.points.toFixed(2));
    };

    this.getCv = function() {
        return this.cv;
    };

    this.getCvFixed = function() {
        return parseFloat(this.cv.toFixed(2));
    };

    this.getPv = function() {
        return this.pv;
    };

    this.getPvFixed = function() {
        return parseFloat(this.pv.toFixed(2));
    };

    this.getPriceType = function() {
        return this.priceType;
    };

    this.getDivision = function() {
        return this.division;
    };

    this.getBackOrderDate = function() {
        return this.backOrderDate;
    };

    this.setPriceAndPvFromType = function(_priceType) {
        let priceType = _priceType ? _priceType : this.priceType;
        this.price = this.getPricing(priceType);
        this.cv = this.getCvWithType(priceType);
        this.pv = this.getPvWithType(priceType);
        this.priceType = priceType;
    };

    this.getPrice = function() {
        return this.price ? this.price : 0;
    };

    this.setPrice = function (price) {
        this.price = insureFloat(price);
    };

    this.getPriceFixed = function() {
        if (typeof this.price === 'number') {
            return parseFloat(this.price.toFixed(2));
        } else {
            return this.getPrice();
        }

    };

    this.getPricing = function(type) {
        return getPricingFromFirebaseObject(type);
    };

    this.getPvWithType = function(type) {
        let rv = getPVFromFirebaseObject(type);
        if (rv == null) {
            // Assumption: we always have WWHL from the service
            // default to wholesale if a PV of a particular type is not there
            rv = getPVFromFirebaseObject(PriceType.WWHL);
        }
        return rv;
    };

    this.getCvWithType = function(type) {
        let rv = getCVFromFirebaseObject(type);
        if (rv == null) {
            rv = getCVFromFirebaseObject(PriceType.WWHL);
        }
        return rv;
    };

    this.addOrderType = function(orderType) {
        this.orderTypes.add(orderType, orderType);
    };

    this.hasAdrOption = function() {
        return this.orderTypes.containsKey('adr');
    };

    this.isAdrOnly = function() {
        return this.hasAdrOption() && !this.hasOrderOption();
    };

    this.hasMultipleOrderTypes = function() {
        return this.hasOrderOption() && this.hasAdrOption();
    };

    this.hasOrderOption = function() {
        return this.orderTypes.containsKey('order');
    };

    this.isDistributor = function() {
        return isCustomerType('10');
    };

    this.isCustomer = function() {
        return isCustomerType('20');
    };

    this.isPreferredCustomer = function() {
        return isCustomerType('30');
    };

    this.toJSON = function() {
        let retData = {};
        retData.sku = this.sku;
        retData.title = this.title;
        retData.cntryCd = this.cntryCd;
        retData.lang = this.lang;
        retData.shortDescr = this.shortDescr;
        retData.longDescr = this.longDescr;
        retData.fullImage = this.fullImage;
        retData.thumbnail = this.thumbnail;
        retData.scanQualified = this.scanQualified;
        retData.available = this.available;
        retData.searchable = this.searchable;
        retData.points = this.points;
        retData.cv = this.cv;
        retData.pv = this.pv;
        retData.priceType = this.priceType;
        retData.price = this.price;
        retData.orderTypes = getKeyArray(this.orderTypes);
        retData.custTypes = parser.getCustomerTypes();
        retData.division = this.division;
        retData.backOrderDate = this.backOrderDate;
        retData.agelocme = this.agelocme;

        return retData;
    };

    this.isEmpty = function() {
        return isFieldEmpty(this.sku) &&
            isFieldEmpty(this.title) &&
            isFieldEmpty(this.cntryCd) &&
            isFieldEmpty(this.lang) &&
            isFieldEmpty(this.shortDescr) &&
            isFieldEmpty(this.longDescr) &&
            isFieldEmpty(this.fullImage) &&
            isFieldEmpty(this.thumbnail) &&
            isFieldEmpty(this.points) &&
            isFieldEmpty(this.cv) &&
            isFieldEmpty(this.pv);
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getPricingFromFirebaseObject(priceType){
        let price;

        switch (priceType) {
            case PriceType.ADR:
                price = user && !user.isCustomer() ? parser.getAdrPreferredPrice() : parser.getAdrRetailPrice();
                break;
            case PriceType.ADW:
                price = parser.getAdrWholesalePrice();
                break;
            case PriceType.RTL:
                price = user && !user.isCustomer() ? parser.getPreferredPrice() : parser.getRetailPrice();
                break;
            case PriceType.WHL:
                price = parser.getWholesale();
                break;
            case PriceType.PTS:
                price = parser.getPoints();
                break;
            case PriceType.WADR:
                price = user && !user.isCustomer() ? parser.getWebAdrWholesalePrice() : parser.getWebAdrRetailPrice();
                break;
            case PriceType.WADW:
                price = parser.getWebAdrWholesalePrice();
                break;
            case PriceType.WADWD:
                // todo We need to figure out what this maps to.
                price = 0.00;
                break;
            case PriceType.WRTL:
                price = user && !user.isCustomer() ? parser.getWebPreferredPrice() : parser.getWebRetailPrice();
                break;
            case PriceType.WWHL:
                price = parser.getWebWholesalePrice();
                break;
            default:
                price = 0.00;
                break;
        }

        return price;
    }

    // todo Verify this logic.
    function getPVFromFirebaseObject(priceType){
        let pv;

        switch (priceType) {
            case PriceType.ADR:
                pv = 0.00;
                break;
            case PriceType.ADW:
                pv = parser.getWebWholesalePv();
                break;
            case PriceType.RTL:
                pv = 0.00;
                break;
            case PriceType.WHL:
                pv = parser.getWebWholesalePv();
                break;
            case PriceType.PTS:
                pv = 0.00;
                break;
            case PriceType.WADR:
                pv = 0.00;
                break;
            case PriceType.WADW:
                pv = parser.getWebWholesalePv();
                break;
            case PriceType.WADWD:
                pv = parser.getWebAdrRetailPv();
                break;
            case PriceType.WRTL:
                pv = parser.getWebWholesalePv();
                break;
            case PriceType.WWHL:
                pv = parser.getWebWholesalePv();
                break;
            default:
                pv = 0.00;
                break;
        }

        return pv;
    }

    // todo Verify this logic.
    function getCVFromFirebaseObject(priceType){
        let cv;

        switch (priceType) {
            case PriceType.ADR:
                cv = 0.00;
                break;
            case PriceType.ADW:
                cv = parser.getWebWholesaleCv();
                break;
            case PriceType.RTL:
                cv = 0.00;
                break;
            case PriceType.WHL:
                cv = parser.getWebWholesaleCv();
                break;
            case PriceType.PTS:
                cv = 0.00;
                break;
            case PriceType.WADR:
                cv = 0.00;
                break;
            case PriceType.WADW:
                cv = parser.getWebWholesaleCv();
                break;
            case PriceType.WADWD:
                cv = parser.getWebAdrRetailCv();
                break;
            case PriceType.WRTL:
                cv = parser.getWebWholesaleCv();
                break;
            case PriceType.WWHL:
                cv = parser.getWebWholesaleCv();
                break;
            default:
                cv = 0.00;
        }

        return cv;
    }

    function isFieldEmpty(fieldValue){
        return fieldValue === null || fieldValue === undefined || fieldValue.length === 0;
    }

    function getKeyArray(jqueryHashtable) {
        let keys,
            i,
            retVal = [];

        if (jqueryHashtable instanceof $.Hashtable) {
            keys = Object.keys(jqueryHashtable.items);
            for (i = 0; i < keys.length; i++) {
                retVal.push(keys[i]);
            }
        }
        return retVal;
    }

    function isCustomerType(customerType) {
        let isCustomerType = false;
        let customerTypes = parser.getCustomerTypes();
        for (let i=0;i<customerTypes.length;i++){
            if (customerTypes[i] === customerType){
                isCustomerType = true;
                break;
            }
        }
        return isCustomerType;
    }

    function insureFloat(price) {
        let floatPrice = parseFloat(price);
        return isNaN(floatPrice) ? 0.00 : floatPrice;
    }

    // ---------------------------------------------
    //
    //        Constructor
    //
    // ---------------------------------------------
    // Add all the order types;
    let orderTypes = parser.getOrderTypes();
    for (let i=0;i<orderTypes.length;i++){
        this.addOrderType(orderTypes[i]);
    }

    this.sku = parser.getSku();
    this.title = parser.getName();
    this.cntryCd = market;
    this.lang = parser.getLanguage();
    this.shortDescr = parser.getShortDescription();
    this.longDescr = parser.getLongDescription();
    this.fullImage = parser.getFullImageUrl();
    this.thumbnail = parser.getImageUrl();
    this.scanQualified = parser.getScanQualified();
    this.available = parser.getAvailable();
    this.searchable = parser.getSearchable();
    this.points = parser.getPoints();
    this.priceType = priceType;
    this.division = null;
    this.backOrderDate = null;
    this.price = this.getPricing(priceType);
    this.pv = this.getPvWithType(priceType);
    this.cv = this.getCvWithType(priceType);
    this.size = parser.getSize();

    this.agelocme = null; // object containing agelocme information (like code, label, name)
};

newShop.FirebaseProduct = FirebaseProduct;

export default FirebaseProduct;
